/*** IMPORTS FROM imports-loader ***/
var define = false;

// Create a simple path alias to allow browserify to resolve
// the runtime on a supported path.
module.exports = require('./dist/cjs/handlebars.runtime')['default'];

